import RestClient from './rest-client'

export default class UserPrice extends RestClient {
  static get url () {
    if (!this._userId) {
      throw new Error('User ID is required!')
    }
    return this.apiUrl + `/users/${this._userId}/user_prices`
  }
  
  static get paramKey () {
    return 'user_price'
  }

  static set userId (val) {
    this._userId = val
  }

  async update () {
    const paramName = this.constructor.name.snakeCase()
    const payload = {}
    payload[paramName] = { ...this }
    const { data } = await this.constructor._post(this.constructor.url, payload)
    this._setAttributes(data.data)

    return true
  }
}
